import { FlexProps } from '@chakra-ui/react';
import { useMenuContext } from '../MenuContext';
import NavButton from './components/NavButton';
import NavButtonsContainer from './components/NavButtonsContainer';

const buttonContainerProps = {
  position: 'absolute',
} as Partial<FlexProps>;

export function NavContainer() {
  const [menuState] = useMenuContext();

  return menuState === 'open' ? (
    <NavButtonsContainer mb="17px">
      <NavButton page="invite-friends" />
      <NavButton page="settings" />
      <NavButton page="help-center" />
      <NavButton page="my-shows" />
    </NavButtonsContainer>
  ) : (
    <NavButtonsContainer {...buttonContainerProps} bottom="110px">
      <NavButton page="invite-friends" />
      <NavButton page="settings" px="13px" />
      <NavButton page="help-center" px="13px" />
      <NavButton page="my-shows" px="13px" />
    </NavButtonsContainer>
  );
}
